const STORAGE_KEY = 'omni_header_search_recents_v1';
const MAX_RECENTS = 8;

export type OmniSearchRecent =
  | {
      kind: 'nav';
      path: string;
      label: string;
    }
  | {
      kind: 'creator';
      query: string;
    };

type StoredRecent =
  | { kind: 'nav'; path: string; label: string; ts: number }
  | { kind: 'creator'; query: string; ts: number };

function readStored(): StoredRecent[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? (parsed as StoredRecent[]) : [];
  } catch {
    return [];
  }
}

function writeStored(items: StoredRecent[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch {
    /* quota / private mode */
  }
}

export function getOmniSearchRecents(): OmniSearchRecent[] {
  return readStored()
    .sort((a, b) => b.ts - a.ts)
    .slice(0, MAX_RECENTS)
    .map((r) =>
      r.kind === 'nav'
        ? { kind: 'nav', path: r.path, label: r.label }
        : { kind: 'creator', query: r.query }
    );
}

export function addOmniSearchRecentNav(path: string, label: string): void {
  const now = Date.now();
  const items = readStored().filter(
    (r) => !(r.kind === 'nav' && r.path === path)
  );
  items.unshift({ kind: 'nav', path, label, ts: now });
  writeStored(items.slice(0, MAX_RECENTS));
}

export function addOmniSearchRecentCreatorQuery(query: string): void {
  const q = query.trim();
  if (!q) return;
  const now = Date.now();
  const items = readStored().filter(
    (r) => !(r.kind === 'creator' && r.query.toLowerCase() === q.toLowerCase())
  );
  items.unshift({ kind: 'creator', query: q, ts: now });
  writeStored(items.slice(0, MAX_RECENTS));
}

export function clearOmniSearchRecents(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
